import React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";

// Register fonts
Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    borderRadius: "5px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
  },
});

export default function AboutReportFirst360() {
  return (
    <div>
      <View style={styles.coverSection}>
        <View>
          <Text style={styles.coverTitle}>ABOUT YOUR REPORT</Text>
          <Text style={styles.paragraph}>
            Your Quadrant Flow assessment offers a structured analysis of your
            life and leadership, grounded in standardized testing. Such insights
            are invaluable for navigating decisions, career planning, and
            personal growth. However, it's crucial to recognize the inherent
            limitations of any assessment, especially a self-assessment limited
            to your own perspective of yourself. 
          </Text>
          <Text style={styles.paragraph}>
            Our 360 assessments include the combined data of selected Observers,
            allowing for objective conversation results. Quadrant Flow is a
            valid and reliable psychometric assessment but your results should
            be used as a starting point for discovery rather than conclusive
            judgment. Interpretations of the data can vary and may not be fully
            captured by the results. 
          </Text>
          <Text style={styles.paragraph}>
            For these reasons, it's highly recommended to review and interpret
            your Quadrant Flow assessment alongside a certified guide, coach,
            consultant, or trusted individual. This collaborative approach
            ensures that the insights gained are integrated thoughtfully into
            your personal and professional development plans. Remember, this
            report is a tool to aid in understanding yourself better, not a
            definitive measure of your capabilities or worth. 
          </Text>
          <Text style={styles.paragraph}>
            Quadrant Flow is not just a concept but a call to action, a
            blueprint for living a life of authenticity and fulfillment. It
            challenges us to look beyond the superficiality of societal norms
            and delve into the four dimensions of being human. By understanding
            these dimensions, we unlock the power that is uniquely ours. This
            power enables us to lead with wisdom and compassion, to thrive in
            our personal and professional lives, and to contribute to the
            greater good.
          </Text>
        </View>
      </View>
    </div>
  );
}
